import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import toast from 'react-hot-toast';
import { Field, Form } from 'react-final-form';
import Select from 'react-select';
// Import Bootstrap
import 'bootstrap/dist/css/bootstrap.min.css';
import {
  Table, Button, Row, Col, Container, Modal, Form as BootstrapForm,
} from 'react-bootstrap';

// Import Form Elements (Ensure path is correct)
import {
  FormContainer, FormGroup, FormGroupField, FormGroupLabel,
} from '@/shared/components/form/FormElements';
import { AuthContext } from '../../../../../context/AuthContext';

const PaxTable = ({ paxdata, setPaxDetailsHandler }) => {
  const [openPaxEditModal, setOpenPaxEditModal] = useState(false);
  const [itemValue, setItemValue] = useState('');
  const [emailValue, setEmailValue] = useState('');
  const [phoneValue, setPhoneValue] = useState('');
  const [ageGroupValue, setAgeGroupValue] = useState('');
  const [newPaxData, setNewPaxData] = useState(paxdata);
  const [emailError, setEmailError] = useState('');
  const [initaildataForPaxEdit, setInitaildataForPaxEdit] = useState({});
  const { apiGlobal, userid } = useContext(AuthContext);

  const validateEmail = (email) => {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(email);
  };

  const handleEmailChange = (e) => {
    const email = e.target.value;
    setEmailValue(email);

    if (!email) {
      setEmailError('Email is required');
    } else if (!validateEmail(email)) {
      setEmailError('Invalid email format');
    } else {
      setEmailError('');
    }
  };

  useEffect(() => {
    setNewPaxData(paxdata);
  }, [paxdata]);

  const handleAddPax = () => {
    if (!itemValue || !emailValue || !phoneValue || !ageGroupValue) {
      toast.error('Some fields are empty!');
      return;
    }

    const newPax = {
      id: new Date().toISOString(),
      pax_id: 0,
      flag: 0,
      pax_name: itemValue,
      email_id: emailValue,
      mobile_no: phoneValue,
      age_group: ageGroupValue,
    };

    const updatedPaxData = [...newPaxData, newPax];
    setNewPaxData(updatedPaxData);
    setPaxDetailsHandler(updatedPaxData);

    setItemValue('');
    setEmailValue('');
    setPhoneValue('');
    setAgeGroupValue('');
  };

  const handleRemovePax = (id) => {
    const updatedPaxData = newPaxData.filter(pax => pax.pax_id !== id);
    setNewPaxData(updatedPaxData);
    setPaxDetailsHandler(updatedPaxData);
  };

  const editPaxhandler = async (values) => {
      // console.log(JSON.stringify(values, null, 2));

        
      if (!values.pax_name || !values.email_id || !values.mobile_no || !values.age_group) {
        toast.error('Some fields are empty!');
        return;
      }

      const formdata = new FormData();
      formdata.append('user_id', userid);
      formdata.append('id', values.pax_id);
      formdata.append('pax_name', values.pax_name);
      formdata.append('email_id', values.email_id);
      formdata.append('mobile_no', values.mobile_no);
      formdata.append('age_group', values.age_group);


      try {
         const url = await fetch(`${apiGlobal}/pax_edit.php`, {
          method: 'POST',
          body: formdata,
         });
         const data = await url.json();
        if (data.status && data.message === 'Record updated successfully.') {
          toast.success('Pax updated successfully!');
          setOpenPaxEditModal(false);
             // ✅ Update edited Pax in local state
      const updatedList = newPaxData.map(pax => (pax.pax_id === values.pax_id
          ? { ...pax, ...values }
          : pax));

      setNewPaxData(updatedList);
      setPaxDetailsHandler(updatedList); // Optional: inform parent
          setInitaildataForPaxEdit({});
        } else {
          toast.error('Pax not updated!');
        }
      } catch (error) {
        console.log(error);
      }
  };

  const groupOptions = [
    { value: '1', label: 'Adult' },
    { value: '2', label: 'Child' },
  ];

  const editpaxtranport = (paxid, paxname, emailid, mobileno, agegroup) => {
    setOpenPaxEditModal(true);
    setInitaildataForPaxEdit({
      pax_id: paxid,
      pax_name: paxname,
      email_id: emailid,
      mobile_no: mobileno,
      age_group: agegroup,
    });
  };

  

  return (
    <Container className="mt-4">
      <div className="table-responsive">
        <Table striped bordered hover className="table-sm align-middle text-nowrap">
          <thead className="thead-dark">
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Email</th>
              <th>Phone Number</th>
              <th>Age Group</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {newPaxData.map((pax, index) => (
              <tr key={pax.pax_id}>
                <td>{index + 1}</td>
                <td>{pax.pax_name}</td>
                <td>{pax.email_id}</td>
                <td>{pax.mobile_no}</td>
                <td>{pax.age_group === '1' ? 'Adult' : 'Child'}</td>
                <td style={{ display: 'flex', gap: '5px' }}>
                  {pax.flag === 0 && (
                  <Button variant="danger" size="sm" onClick={() => handleRemovePax(pax.pax_id)}>
                    Remove
                  </Button>
                )}
                  {pax.flag === 1 && (
                  <Button variant="primary" size="sm" disabled>
                    Used
                  </Button>
                )}
                

                  {pax.pax_id !== 0 && (
                  <Button 
                    variant="warning"
                    size="sm"
                    onClick={() => editpaxtranport(
pax.pax_id, 
 pax.pax_name,
pax.email_id,
pax.mobile_no,
pax.age_group,
)}
                  >
                    Edit
                  </Button>
                )}
                
                </td>
              </tr>
          ))}
          </tbody>
        </Table>
      </div>

      <h4 className="mt-4 text-center">Add More Pax</h4>
      <BootstrapForm className="p-3 border rounded bg-light">
        <Row className="mb-3">
          <Col md={6}>
            <BootstrapForm.Group>
              <BootstrapForm.Label>Name</BootstrapForm.Label>
              <BootstrapForm.Control
                type="text"
                placeholder="Enter Name"
                value={itemValue}
                onChange={e => setItemValue(e.target.value)}
              />
            </BootstrapForm.Group>
          </Col>
          <Col md={6}>
            <BootstrapForm.Group>
              <BootstrapForm.Label>Email</BootstrapForm.Label>
              <BootstrapForm.Control
                type="email"
                placeholder="Enter Email"
                value={emailValue}
                onChange={handleEmailChange}
                isInvalid={!!emailError}
              />
              {emailError 
              && <BootstrapForm.Control.Feedback type="invalid">{emailError}</BootstrapForm.Control.Feedback>}
            </BootstrapForm.Group>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col md={6}>
            <BootstrapForm.Group>
              <BootstrapForm.Label>Phone No.</BootstrapForm.Label>
              <BootstrapForm.Control
                type="tel"
                placeholder="Enter 12-digit Phone No."
                value={phoneValue}
                onChange={(e) => {
                  const input = e.target.value.replace(/\D/g, '');
                  if (input.length <= 12) setPhoneValue(input);
                }}
                maxLength={12}
                required
              />
              <BootstrapForm.Text className="text-muted">
                Please enter a 12-digit phone number.
              </BootstrapForm.Text>
            </BootstrapForm.Group>
          </Col>
          <Col md={6}>
            <BootstrapForm.Group>
              <BootstrapForm.Label>Age Group</BootstrapForm.Label>
              <BootstrapForm.Select value={ageGroupValue} onChange={e => setAgeGroupValue(e.target.value)}>
                <option value="">Select Age Group</option>
                <option value="1">Adult</option>
                <option value="2">Child</option>
              </BootstrapForm.Select>
            </BootstrapForm.Group>
          </Col>
        </Row>

        <div className="text-center mt-3">
          <Button variant="primary" size="lg" onClick={handleAddPax}>
            Add Pax
          </Button>
        </div>
      </BootstrapForm>

      <Modal show={openPaxEditModal} onHide={() => setOpenPaxEditModal(false)} centered size="md">
        <Modal.Header closeButton>
          <Modal.Title>Edit Pax</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={editPaxhandler} initialValues={initaildataForPaxEdit}>
            {({ handleSubmit }) => (
              <FormContainer onSubmit={handleSubmit}>
                <FormGroup>
                  <FormGroupLabel>Name<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                  <FormGroupField>
                    <Field
                      name="pax_id" 
                      style={{ display: 'none' }}
                      component="input"
                      type="text"
                      placeholder="Pax Name"
                    />
                    <Field name="pax_name" component="input" type="text" placeholder="Pax Name" />
                  </FormGroupField>
                </FormGroup>
                <FormGroup>
                  <FormGroupLabel>Pax Email<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                  <FormGroupField>
                    <Field name="email_id" component="input" type="email" placeholder="Pax Email" />
                  </FormGroupField>
                </FormGroup>
                <FormGroup>
                  <FormGroupLabel>Pax Mobile no.<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                  <FormGroupField>
                    <Field
                      name="mobile_no" 
                      component="input"
                      type="number"
                      maxLength={12}
                      placeholder="Pax Mobile no"
                    />
                  </FormGroupField>
                </FormGroup>
                <FormGroup>
                  <FormGroupLabel>Select Group<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                  <Field
                    name="age_group"
                    render={({ input, meta }) => (
                      <Select
                        {...input} 
                        name="age_group"
                        className="react-select"
                        classNamePrefix="react-select"
                        options={groupOptions}
                        value={groupOptions.find(option => option.value === input.value) || null}
                        onChange={option => input.onChange(option?.value)}
                      />
                      )}
                  />
                </FormGroup>
                <Button type="submit">Submit</Button>
              </FormContainer>
            )}
          </Form>
        </Modal.Body>
      </Modal>
    </Container>
  );
};

PaxTable.propTypes = {
  paxdata: PropTypes.arrayOf.isRequired,
  setPaxDetailsHandler: PropTypes.func.isRequired,
};

export default PaxTable;




// code for re-review 
// import React, { useState } from 'react';
// import PropTypes from 'prop-types';
// import 'bootstrap/dist/css/bootstrap.min.css';

// // Your existing PaxTable component
// const PaxTable = ({ paxdata, setPaxDetailsHandler }) => {
//   const [itemValue, setItemValue] = useState('');
//   const [emailValue, setEmailValue] = useState('');
//   const [phoneValue, setPhoneValue] = useState('');
//   const [ageGroupValue, setAgeGroupValue] = useState('');
//   const [newPaxData, setNewPaxData] = useState(paxdata);

//   const handleAddPax = () => {
//     const newPax = {
//       pax_id: new Date().toISOString(), // Generate a unique ID using timestamp
//       pax_name: itemValue,
//       email_id: emailValue,
//       mobile_no: phoneValue,
//       age_group: ageGroupValue,
//     };

//     const updatedPaxData = [...newPaxData, newPax];
//     setNewPaxData(updatedPaxData);
//     setPaxDetailsHandler(updatedPaxData);

//     // Reset form fields after adding Pax
//     setItemValue('');
//     setEmailValue('');
//     setPhoneValue('');
//     setAgeGroupValue('');
//   };

//   const handleRemovePax = (id) => {
//     // Filter out the Pax entry by its pax_id
//     const updatedPaxData = newPaxData.filter(pax => pax.pax_id !== id);
//     setNewPaxData(updatedPaxData);
//     setPaxDetailsHandler(updatedPaxData);
//   };


//   return (
//     <div className="container mt-5">
//       {/* Table displaying the Pax data */}
//       <table className="table table-striped table-bordered">
//         <thead className="thead-dark">
//           <tr>
//             <th scope="col">#</th>
//             <th scope="col">Name</th>
//             <th scope="col">Email</th>
//             <th scope="col">Phone Number</th>
//             <th scope="col">Age Group</th>
//             <th scope="col">Actions</th> {/* Added column for actions */}
//           </tr>
//         </thead>
//         <tbody>
//           {newPaxData.map((pax, index) => (
//             <tr key={pax.pax_id}>
//               <th scope="row">{index + 1}</th>
//               <td>{pax.pax_name}</td>
//               <td>{pax.email_id}</td>
//               <td>{pax.mobile_no}</td>
//               <td>{pax.age_group === '1' ? 'Adult' : 'Child'}</td>
//               <td>
//                 <button
//                   type="button"
//                   className="btn btn-danger"
//                   onClick={() => handleRemovePax(pax.pax_id)} // Call handleRemovePax with Pax ID
//                 >
//                   Remove
//                 </button>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>

//       {/* Form for adding more Pax */}
//       <div className="mt-4">
//         <h4>Add More Pax</h4>
//         <div className="form-section">
//           <div className="form-row">
//             {/* Column for name and email */}
//             <div className="col-md-6">
//               <div className="form-group">
//                 <label htmlFor="paxName">Name</label>
//                 <input
//                   id="paxName"
//                   type="text"
//                   className="form-control"
//                   placeholder="Enter Name"
//                   value={itemValue}
//                   onChange={e => setItemValue(e.target.value)}
//                 />
//               </div>
//               <div className="form-group">
//                 <label htmlFor="paxEmail">Email</label>
//                 <input
//                   id="paxEmail"
//                   type="email"
//                   className="form-control"
//                   placeholder="Enter Email"
//                   value={emailValue}
//                   onChange={e => setEmailValue(e.target.value)}
//                 />
//               </div>
//             </div>

//             {/* Column for phone number and age group */}
//             <div className="col-md-6">
//               <div className="form-group">
//                 <label htmlFor="paxPhone">Phone No.</label>
//                 <input
//                   id="paxPhone"
//                   type="number"
//                   className="form-control"
//                   placeholder="Enter Phone No."
//                   value={phoneValue}
//                   onChange={e => setPhoneValue(e.target.value)}
//                 />
//               </div>
//               <div className="form-group">
//                 <label htmlFor="paxAgeGroup">Age Group</label>
//                 <select
//                   id="paxAgeGroup"
//                   className="form-control"
//                   value={ageGroupValue}
//                   onChange={e => setAgeGroupValue(e.target.value)}
//                 >
//                   <option value="">Select Age Group</option>
//                   <option value="1">Adult</option>
//                   <option value="2">Child</option>
//                 </select>
//               </div>
//             </div>
//           </div>

//           <button
//             type="button"
//             className="btn btn-primary mt-3"
//             onClick={handleAddPax}
//           >
//             Add Pax
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// PaxTable.propTypes = {
//   paxdata: PropTypes.arrayOf(
//     PropTypes.shape({
//       pax_id: PropTypes.string.isRequired, // Use pax_id as unique identifier
//       pax_name: PropTypes.string.isRequired,
//       mobile_no: PropTypes.string.isRequired,
//       email_id: PropTypes.string.isRequired,
//       age_group: PropTypes.string.isRequired,
//     }),
//   ).isRequired,
//   setPaxDetailsHandler: PropTypes.func.isRequired,
// };

// export default PaxTable;

